import 'animate.css';
import './styles.css';
import "@lottiefiles/lottie-player";
import app from './src/app';

export const wrapRootElement = app;
